module.exports = __webpack_public_path__ + "img/61d028118dce83820bc3d923461c23bb.svg";